// New File: src/pages/Downtime.js
import React from "react";
import SEO from "../components/common/SEO";
import "../styles/Downtime.css";

const Downtime = () => {
  return (
    <>
      <SEO title="Site Maintenance" noindex nofollow />
      <div className="downtime-container">
      <div className="downtime-content">
        <h1>We're Currently Down for Maintenance</h1>
        <p>
          Sorry for the inconvenience! Our site is temporarily unavailable due to maintenance or an issue with our API.
        </p>
        <p>Please check back soon. If the problem persists, <a href="/contact">contact support</a>.</p>
        <img
          src="/images/maintenance-penguin.jpg"
          alt="Penguin performing maintenance"
          className="downtime-image"
          width="400"
          height="400"
        />
        </div>
      </div>
    </>
  );
};

export default Downtime;
